import React, { useState } from "react";
import NavigationHeader from "../../Components/NavigationHeader/NavigationHeader";
import { ProgressBar } from "react-bootstrap";
import { Link } from "react-router-dom";
import PATH from "./../../constants/routes";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Helmet } from "react-helmet";

export default function Qbank() {
  let subjectPrototype = [
    {
      subjectImage: "bookmark-icon.png",
      id: 1,
      subjectTitle: "Learn C++",
      progressComplete: 20,
      completed: "20% complete",
    },
    {
      id: 2,
      subjectImage: "bookmark-icon.png",
      subjectTitle: "Learn Java",
      progressComplete: 90,
      completed: "90% complete",
    },
    {
      id: 3,
      subjectImage: "bookmark-icon.png",
      subjectTitle: "Learn JS",
      progressComplete: 100,
      completed: "100% complete",
    },
  ];
  type VideoType = {
    id: number;
    subjectImage: string;
    subjectTitle: string;
    progressComplete: number;
    completed: string;
  };

  let videosPrototype = [
    {
      id: 1,
      subjectImage: "bookmark-icon.png",
      subjectTitle: "Learn C++",
      progressComplete: 20,
      completed: "20% complete",
    },
    {
      id: 2,
      subjectImage: "bookmark-icon.png",
      subjectTitle: "Learn Java",
      progressComplete: 90,
      completed: "90% complete",
    },
    {
      id: 3,
      subjectImage: "bookmark-icon.png",
      subjectTitle: "Learn JS",
      progressComplete: 100,
      completed: "100% complete",
    },
  ];

  const [subjects, setSubjects] = useState(subjectPrototype);

  const renderSubjectList = () => {
    return subjects.map((subject, index) => {
      return (
        <Link to={`/${PATH.QBANK}/${subject.id}`} key={index}>
          <li className="custom_card subject" key={subject.id}>
            <div className="card_image_container">
              <img src={subject.subjectImage} alt="subject" />
            </div>
            <div className="card_info_container">
              <h6>{subject.subjectTitle}</h6>
              <div className="progress_container">
                <ProgressBar now={subject.progressComplete} />
                <p className="complete_info">{subject.completed}</p>
              </div>
            </div>
            <MdKeyboardArrowRight className="right_arrow_icon" />
          </li>
        </Link>
      );
    });
  };

  return (
    <>
      <h4 className="list_heading">Subjects</h4>
      <Helmet>
        <title>Qbank</title>
      </Helmet>
      <ul className="list_container subject_container">
        {renderSubjectList()}
      </ul>
    </>
  );
}
